module.exports = __webpack_public_path__ + "img/manual-transmission.7fa88e5c.png";